module.exports = __webpack_public_path__ + "img/truck_stopped.503ca71a.svg";